import React, { useEffect, useState } from "react";
import { List, Datagrid, TextField, DateField, FunctionField, useRedirect, TopToolbar, ExportButton, Button, SelectInput } from "react-admin";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useLocation } from "react-router-dom";
import { formatPhoneNumberStrict, formatPostalCode, getResourceName, isOverdue, monthChoices } from "../common";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const UnCollectList = () => {
  const redirect = useRedirect();
  const [customerPath, setCustomerPath] = useState(null);
  const location = useLocation();
  
  useEffect(() => {
    const pathParts = location.pathname.split("-");
    const secondAndAfter = pathParts.slice(1).join("-"); // 2個目以降を結合
    setCustomerPath(secondAndAfter);
  }, [location.pathname]);

  const UnCollectActions = () => {    
    return (
      <TopToolbar>
        {location.pathname === "/uncollect-inspect"  && <Button label="点検リスト" onClick={() => redirect(`/inspect`)} ><SwapHorizIcon /></Button>}
        <Button label="顧客リスト" onClick={() => redirect(`/customers-${customerPath}`)} startIcon={<SwapHorizIcon />} />
        <ExportButton exporter={customExporter}/>
      </TopToolbar>
    );
  };

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => ({
  //     "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}`, 
  //     "名前": `${record.surname ?? ""} ${record.name ?? ""}`, // フルネーム結合
  //     "会社名": record.companyName ?? "",
  //     "電話番号１": record.phone ? record.phone : "",
  //     "電話番号２": record.telephone ? record.telephone : "",
  //     "FAX": record.fax ? record.fax : "",
  //     "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
  //     "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
  //   }));
  
  //   // CSV のエクスポート
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `未収リスト(${getResourceName(location.pathname)})_` + new Date().toLocaleDateString());
  // };

const customExporter = (records) => {
  const excelData = records.map(record => ({
    "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`, 
    "名前": `${record.surname ?? ""} ${record.name ?? ""}`,
    "会社名": record.companyName ?? "",
    "電話番号１": record.phone ?? "",
    "電話番号２": record.telephone ?? "",
    "FAX": record.fax ?? "",
    "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
    "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
  }));

  // ワークシート作成
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // 任意：列幅の調整
  worksheet['!cols'] = [
    { wch: 60 }, // 住所
    { wch: 20 }, // 名前
    { wch: 25 }, // 会社名
    { wch: 15 }, // 電話番号１
    { wch: 15 }, // 電話番号２
    { wch: 15 }, // FAX
    { wch: 15 }, // 請求日
    { wch: 15 }, // 再発行日
  ];

  // ワークブック作成とシート追加
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, '未収リスト');

  // エクセルファイルとしてバイナリ書き出し
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  // ダウンロードファイル名の動的生成
  const fileName = `未収リスト(${getResourceName(location.pathname)})_${new Date().toLocaleDateString()}.xlsx`;
  saveAs(blob, fileName);
};


  const CustomerFilters = [
    <SelectInput
      source="month"
      label={<span style={{fontSize:"12px"}}>請求月</span>}
      choices={monthChoices}
      alwaysOn
      sx={{
        ".MuiInputBase-root": { height: "35px" }, 
        ".MuiInputBase-input": {
          fontSize: "12px"
        },
      }}
    />
  ];

const handleRowClick = (id, resource) => {
  const url = `${window.location.origin}/#/invoiceHistory/${id}`;
  const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
  window.open(url, '_blank', features);
  return false;
};



  return (
    <List actions={<UnCollectActions />}  filters={CustomerFilters}>
      <Datagrid bulkActionButtons={false} rowClick={(id, resource) => handleRowClick(id, resource)} rowStyle={(record) => isOverdue(record) ? { backgroundColor: "#FFCCCC" } : {}}>
        <FunctionField
          label="住所"
          render={record => {
            return `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`;
          }}
        />
        <FunctionField
          label="顧客名"
          render={record => {
            return `${record.surname ?? ""} ${record.name ?? ""}`;
          }}
        />
        {/* <TextField source="companyName" label="会社名" /> */}
        <FunctionField
          source="phone"
          label="電話番号１"
          render={(record) => record.phone ?? ""}
        />
        <FunctionField
          source="telephone"
          label="電話番号２"
          render={(record) => record.telephone ?? ""}
        />
        <FunctionField
          source="fax"
          label="FAX"
          render={(record) => record.fax ?? ""}
        />
        <DateField source="invoiceDate" label="請求日" />
        <DateField source="reissueDate" label="再発行日" />
      </Datagrid>
    </List>
  );
};

export default UnCollectList;
